import { render, staticRenderFns } from "./CompanyDimensionRefSelect.vue?vue&type=template&id=7c00be9b&scoped=true"
import script from "./CompanyDimensionRefSelect.vue?vue&type=script&lang=js"
export * from "./CompanyDimensionRefSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c00be9b",
  null
  
)

export default component.exports